<template>
  <div>
    <div class="page-navbar shopSales">
      <div class="navbar-header" id="menu_right">
        <mt-navbar id="menu_page_part" class="page-part" v-model="selected">
          <mt-tab-item
            v-for="(item, index) in dateList"
            :key="index"
            :id="index"
          >
            <div @click="searchByDate(item.value)">{{ item.name }}</div>
          </mt-tab-item>
        </mt-navbar>
      </div>

      <div class="page-loadmore">
        <!-- <div class="introduct">
          {{htmlURL}}
        </div>-->
        <!-- <div class="introduct">
          数据概览
          <mt-badge size="small" color="#888">i</mt-badge>
        </div>-->
        <div
          class="page-loadmore-wrapper"
          :style="{ height: wrapperHeight + 'px' }"
        >
          <!-- <mt-spinner v-show="list<1 && InitialLoading" color="#2181d4"></mt-spinner> -->
          <!-- 待开发 <mt-loadmore
            :bottom-method="loadBottom"
            @bottom-status-change="handleBottomChange"
            :bottom-all-loaded="allLoaded"
            ref="loadmore"
            :auto-fill="false"
          >-->
          <mt-loadmore ref="loadmore">
            <!-- <mt-spinner v-show="loading" type="snake" color="#00ccff" :size="20"></mt-spinner> -->
            <div class="page-loadmore-list">
              <!-- 1、营业额 start -->
              <div class="detail" v-if="featureItems[0].Daily_Turnover">
                <p class="title">营业额</p>
                <h6 class="content">
                  <span class="unit">￥</span>
                  <span>{{ shopSalesDetailData.salesMoney }}</span>
                </h6>
                <p class="compare">
                  较上{{ weekDay }}
                  <span>{{ shopSalesDetailData.moneyChangePer }}</span>
                </p>
                <div class="compare-detail">
                  <div>
                    <p class="compare-detail-title">交易笔数</p>
                    <p class="compare-detail-content">
                      {{ shopSalesDetailData.salesCount }}
                    </p>
                    <p class="compare-detail-value">
                      {{ shopSalesDetailData.countChangePer }}
                    </p>
                  </div>
                  <div>
                    <p class="compare-detail-title">优惠额</p>
                    <p class="compare-detail-content">
                      {{ shopSalesDetailData.rebateMoney }}
                    </p>
                    <p class="compare-detail-value isDiff">
                      {{ shopSalesDetailData.rebateChangePer }}
                    </p>
                  </div>
                  <div>
                    <p class="compare-detail-title">毛利</p>
                    <p class="compare-detail-content">
                      {{ shopSalesDetailData.profit }}
                    </p>
                    <p class="compare-detail-value">
                      {{ shopSalesDetailData.profitChangePer }}
                    </p>
                  </div>
                </div>
                <div
                  class="check-trends"
                  @click="jumpTradTrends"
                  v-if="featureItems[0].Daily_BusinessTrendData"
                >
                  查看趋势数据>
                  <!-- <router-link :to="{path:'/tradTrends',query:{deptId:deptId}}">查看趋势数据></router-link> -->
                </div>
              </div>
              <!-- 1、营业额 end -->
              <!-- 2、客单价 start -->
              <!-- <div class="detail">
                <p class="title">客单价</p>
               
                <div id="main1" class="cakeSales" style="height: 200px" v-show="noContent"></div>
                <div class="noContent" v-if="!noContent">暂无销售数据</div>
                <div class="cakeSales-detail">
                  <div class="cakeSales-detail-label">&nbsp;</div>
                  <div class="cakeSales-detail-name">生日蛋糕</div>
                  <div class="cakeSales-detail-value">客单价：{{shopSalesDetailData.cakeSalesPrice}}</div>
                  <div class="cakeSales-detail-per">{{shopSalesDetailData.cakePriceChangePer}}</div>
                </div>
                <div class="cakeSales-detail isDiff">
                  <div class="cakeSales-detail-label">&nbsp;</div>
                  <div class="cakeSales-detail-name">非生日蛋糕</div>
                  <div class="cakeSales-detail-value">客单价：{{shopSalesDetailData.norSalesPrice}}</div>
                  <div class="cakeSales-detail-per">{{shopSalesDetailData.norPriceChangePer}}</div>
                </div>
              </div> -->
              <!-- 2、客单价 end -->
              <!-- 3、营业额构成 start -->
              <div
                class="detail"
                v-if="featureItems[0].Daily_TurnoverComposition"
              >
                <p class="title">营业额构成</p>
                <div class="progress-detail">
                  <template
                    v-if="shopSalesPayDetail && shopSalesPayDetail.length > 0"
                  >
                    <mt-progress
                      v-for="(item, index) in shopSalesPayDetail"
                      :value="
                        (item.moneyPercent /
                          shopSalesPayDetail[0].moneyPercent) *
                        100
                      "
                      :key="index"
                      :bar-height="5"
                    >
                      <div slot="start" class="start-txt">
                        {{ item.moneyPercent }}%
                      </div>
                      <div
                        slot="end"
                        class="end-txt"
                        v-bind:class="{ endTxt2: txt }"
                      >
                        {{ item.money }}({{ item.payTypeName }})
                      </div>
                    </mt-progress>
                  </template>
                  <template v-else>暂无数据</template>
                </div>
              </div>
              <!-- 3、营业额构成 end -->
              <!-- 4、充值统计 start -->
              <!-- <div class="detail">
                <p class="title">充值统计</p>
                <div class="compare-detail">
                  <div>
                    <p class="compare-detail-title">充值总额</p>
                    <p class="compare-detail-content">{{shopSalesRechargeData.rechargeAmount}}</p>
                    <p class="compare-detail-value">{{shopSalesRechargeData.amountChangePer}}</p>
                  </div>
                  <div>
                    
                    <p class="compare-detail-title">赠送总额</p>
                    <p class="compare-detail-content">{{shopSalesRechargeData.rechargePresent}}</p>
                    <p class="compare-detail-value isDiff">{{shopSalesRechargeData.presentChangePer}}</p>
                  </div>
                  <div>
                    <p class="compare-detail-title">笔数</p>
                    <p class="compare-detail-content">{{shopSalesRechargeData.rechargeCount}}</p>
                    <p class="compare-detail-value">{{shopSalesRechargeData.countChangePer}}</p>
                  </div>
                </div>
              </div> -->
              <!-- 4、充值统计 end -->
              <!-- 5、报废统计 start -->
              <!-- <div class="detail">
                <p class="title">报废统计</p>
                <div class="compare-detail">
                  <div>
                    <p class="compare-detail-title">报废金额</p>
                    <p class="compare-detail-content">{{shopSalesDetailData.returnMoney}}</p>
                    <p class="compare-detail-value">{{shopSalesDetailData.returnMoneyChangePer}}</p>
                  </div>
                  <div>
                    <p class="compare-detail-title">报废成本</p>
                    <p class="compare-detail-content">{{shopSalesDetailData.returnCost}}</p>
                    <p class="compare-detail-value isDiff">{{shopSalesDetailData.returnCostChangePer}}</p>
                  </div>
                  <div>
                    <p class="compare-detail-title">报废率</p>
                    <p class="compare-detail-content">{{shopSalesDetailData.returnPercent}}</p>
                    <p class="compare-detail-value">{{shopSalesDetailData.returnPercentChangePer}}</p>
                  </div>
                </div>
              </div> -->
              <!-- 5、报废统计 end -->
              <!-- 6、门店一览 start -->
              <div
                class="detail"
                v-if="!deptId && featureItems[0].Daily_BirdsEye"
              >
                <p class="title">门店一览</p>
                <p class="title-sub">(点击门店查看门店营业详情)</p>
                <div class="detail-table">
                  <div class="name">名称</div>
                  <div class="turnover">营业额</div>
                  <div class="profit">毛利</div>
                </div>
                <template
                  v-if="shopSalesAllShop && shopSalesAllShop.length > 0"
                >
                  <div
                    v-for="(item, index) in shopSalesAllShop"
                    class="detail-table-content"
                    v-bind:class="{ isEven: index % 2 == 0 }"
                    :key="index"
                    @click="showSalesByShop(item.deptId, item.deptName)"
                  >
                    <div class="name">{{ item.deptName }}</div>
                    <div class="turnover">
                      <p>{{ item.salesMoney }}</p>
                      <p>{{ item.moneyComparePer }}%</p>
                    </div>
                    <div class="profit">
                      <p>{{ item.profit }}</p>
                      <p>{{ item.profitComparePer }}%</p>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="notxt">暂无数据</div>
                </template>
              </div>
              <!-- 6、门店一览 end -->
            </div>
            <!-- <div slot="bottom" class="mint-loadmore-bottom">
              <span
                v-show="bottomStatus !== 'loading'"
                :class="{'is-rotate': bottomStatus === 'drop'}"
              >↑</span>
              <span v-show="bottomStatus === 'loading'">
                <mt-spinner type="snake"></mt-spinner>
              </span>
            </div>-->
          </mt-loadmore>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { Toast } from "mint-ui";
import shopSalesDetailApi from "@/api/api-shopSalesDetail";
import permissionApi from "@/api/api-permission";
import commonFun from "@/libs/commonFun";
import { localToken, cache, toolFunc } from "@/libs/func";
import { Indicator } from "mint-ui";
export default {
  name: "shopSales",
  data() {
    return {
      loading: true,
      title: "皇爷营业详情",
      selected: 34,
      selectedOld: 34,
      salesDate: "",
      weekDay: "",
      dateList: [],
      examplename: "PullUp",
      list: [
        { title: "营业额", value: "$10000" },
        { title: "客单价", value: "$10000" },
        { title: "营业额构成", value: "$10000" },
        { title: "充值统计", value: "$10000" },
        { title: "报废统计", value: "$10000" },
      ],
      InitialLoading: true,
      allLoaded: false,
      bottomStatus: "",
      wrapperHeight: 0,
      //数据 start
      //  营业额，客单价，报废
      shopSalesDetailData: {
        // 营业额
        salesMoney: null, // 营业额
        salesCount: null, // 交易笔数
        rebateMoney: null, // 优惠
        profit: null, // 毛利
        moneyChangePer: null, // 营业额变化
        countChangePer: null, // 交易笔数变化
        rebateChangePer: null, // 优惠变化
        profitChangePer: null, // 毛利变化
        // 生日蛋糕
        cakeSalesCount: null, // 生日蛋糕笔数
        norSalesCount: null, // 非生日蛋糕笔数
        cakeSalesPrice: null, // 生日蛋糕客单价
        norSalesPrice: null, // 非生日蛋糕客单价
        cakePriceChangePer: null, // 生日蛋糕客单价变化
        norPriceChangePer: null, // 非生日蛋糕客单价变化
        // 报废
        returnMoney: null, // 报废金额
        returnPercent: null, // 报废率
        returnCost: null, // 报废成本
        returnMoneyChangePer: null, // 报废金额变化
        returnPercentChangePer: null, // 报废率变化
        returnCostChangePer: null, // 报废成本变化
      },
      // 充值
      shopSalesRechargeData: {
        amountChangePer: null, // 充值金额变化
        presentChangePer: null, // 赠送金额变化
        countChangePer: null, // 充值笔数变化
        rechargeAmount: null, // 充值金额
        rechargePresent: null, // 赠送金额
        rechargeCount: null, // 充值笔数
      },
      // 营业额构成
      shopSalesPayDetail: [],
      // 门店一览
      shopSalesAllShop: [],
      deptId: "",
      deptName: "",
      txt: true, //是否调整样式
      htmlURL: "",
      isEnd: 0,
      noContent: true,
      isAllDept: true,
      dataItems: [],
      featureItems: [
        {
          Daily_BirdsEye: false, // 门店一览
          Daily_TurnoverComposition: false, // 营业额构成
          Daily_BusinessTrendData: false, // 营业趋势数据
          Daily_Turnover: false, // 营业额
        },
      ],
    };
  },
  methods: {
    initData() {
      // 测试方法
      // this.htmlURL = localToken.getURL();
      this.isEnd = 0;
      Indicator.open({
        text: "数据加载中",
        spinnerType: "fading-circle",
      });
      this.deptId = this.$route.query.deptId || "";
      let deptName = this.$route.query.deptName || "";
      let selected = this.$route.query.selected || "";
      if (deptName) {
        this.deptName = deptName;
        document.title = deptName;
      }
      // 获取日期列
      var date1 = new Date();
      let salesDate = commonFun.getTime(date1);
      this.dateList = this.getDateList(date1, salesDate);
      let width = $("#menu_page_part")[0].offsetWidth;
      let selectWidth = parseInt(width / 35);
      let scrollWidth = $("#menu_right")[0].scrollWidth;
      if (selected) {
        this.salesDate = this.dateList[selected].value;
        this.selected = parseInt(selected);
        this.selectedOld = parseInt(selected);
        scrollWidth = parseInt(selected) * selectWidth;
      } else {
        this.salesDate = salesDate;
        this.selected = 34;
        this.selectedOld = 34;
        scrollWidth = parseInt(this.selected) * selectWidth;
      }
      this.weekDay = commonFun.getWeekDay(this.salesDate);
      // $(document).scrollTop();//获取，兼容火狐谷歌
      // $("#menu_right").animate({
      //   scrollTop: $("#menu_right")[0].scrollHeight,
      //   scrollLeft: $("#menu_right")[0].scrollWidth
      // }); //动画滚动效果，兼容火狐谷歌
      $("#menu_right").animate({
        scrollTop: $("#menu_right")[0].scrollHeight,
        scrollLeft: parseInt(scrollWidth),
      }); //动画滚动效果，兼容火狐谷歌
      //  营业额，客单价，报废
      this.getShopSalesDetail();
      // 充值
      // this.getShopSalesRecharge();
      // 营业额构成
      this.getShopSalesPayDetail();
      // 门店一览
      if (!this.deptId) {
        this.getShopSalesAllShop();
      }
    },
    initData2() {
      this.isEnd = 0;
      Indicator.open({
        text: "数据加载中",
        spinnerType: "fading-circle",
      });
      let deptName = this.$route.query.deptName || "";
      if (deptName) {
        this.deptName = deptName;
        document.title = deptName;
      }
      //  营业额，客单价，报废
      this.getShopSalesDetail();
      // 充值
      // this.getShopSalesRecharge();
      // 营业额构成
      this.getShopSalesPayDetail();
      // 门店一览
      if (!this.deptId) {
        this.getShopSalesAllShop();
      }
    },
    // 获取顶部时间按钮
    getDateList(date1, value) {
      let arr = [];
      for (var i = 34; i > 0; i--) {
        var date2 = new Date(date1.getTime() - i * 24 * 60 * 60 * 1000);
        let temp = {
          name: commonFun.getTime6(date2),
          value: commonFun.getTime(date2),
        };
        arr.push(temp);
      }
      let temp1 = {
        name: commonFun.getTime6(date1),
        value: value,
      };
      arr.push(temp1);
      return arr;
    },
    //  营业额，客单价，报废
    getShopSalesDetail() {
      let that = this;
      let data = {
        DeptId: that.deptId,
        SalesDate: that.salesDate,
      };
      if (that.deptId != "" && that.deptId != null) {
        data["IsAllDept"] = false;
        data["deptIds"] = new Array(that.deptId);
      } else {
        if (that.isAllDept == true) {
          data["IsAllDept"] = true;
        } else {
          data["deptIds"] = that.dataItems.length > 0 ? that.dataItems : null;
          data["IsAllDept"] = false;
        }
      }
      that.loading = true;
      shopSalesDetailApi.getShopSalesDetail(data).then(
        (res) => {
          that.shopSalesDetailData = {
            // 营业额
            salesMoney: commonFun.getNumberFormatter(res.salesMoney + ""), // 营业额
            salesCount: commonFun.getNumberFormatter(res.salesCount + ""), // 交易笔数
            rebateMoney: commonFun.getNumberFormatter(res.rebateMoney + ""), // 优惠
            profit: commonFun.getNumberFormatter(res.profit + ""), // 毛利
            moneyChangePer:
              (res.moneyChangePer < 0 ? "" : "+") +
              commonFun.formatDecimal(res.moneyChangePer + "") +
              "%", // 营业额变化
            countChangePer:
              (res.countChangePer < 0 ? "" : "+") +
              commonFun.formatDecimal(res.countChangePer + "") +
              "%", // 交易笔数变化
            rebateChangePer:
              (res.rebateChangePer < 0 ? "" : "+") +
              commonFun.formatDecimal(res.rebateChangePer + "") +
              "%", // 优惠变化
            profitChangePer:
              (res.profitChangePer < 0 ? "" : "+") +
              commonFun.formatDecimal(res.profitChangePer + "") +
              "%", // 毛利变化

            // // 生日蛋糕
            // cakeSalesAllPrice: res.cakeSalesCount * res.cakeSalesPrice, // 生日蛋糕消费金额
            // norSalesAllPrice: res.norSalesCount * res.norSalesPrice, // 非生日蛋糕消费金额
            // cakeSalesCount: res.cakeSalesCount, // 生日蛋糕笔数
            // norSalesCount: res.norSalesCount, // 非生日蛋糕笔数
            // cakeSalesPrice: commonFun.getNumberFormatter(
            //   res.cakeSalesPrice + ""
            // ), // 生日蛋糕客单价
            // norSalesPrice: commonFun.getNumberFormatter(res.norSalesPrice + ""), // 非生日蛋糕客单价
            // cakePriceChangePer:
            //   (res.cakePriceChangePer < 0 ? "" : "+") +
            //   commonFun.formatDecimal(res.cakePriceChangePer + "") +
            //   "%", // 生日蛋糕客单价变化
            // norPriceChangePer:
            //   (res.norPriceChangePer < 0 ? "" : "+") +
            //   commonFun.formatDecimal(res.norPriceChangePer + "") +
            //   "%", // 非生日蛋糕客单价变化

            // // 报废
            // returnMoney: commonFun.getNumberFormatter(res.returnMoney + ""), // 报废金额
            // returnPercent: commonFun.getNumberFormatter(res.returnPercent + ""), // 报废率
            // returnCost: commonFun.getNumberFormatter(res.returnCost + ""), // 报废成本
            // returnMoneyChangePer:
            //   (res.returnMoneyChangePer < 0 ? "" : "+") +
            //   commonFun.formatDecimal(res.returnMoneyChangePer + "") +
            //   "%", // 报废金额变化
            // returnPercentChangePer:
            //   (res.returnPercentChangePer < 0 ? "" : "+") +
            //   commonFun.formatDecimal(res.returnPercentChangePer + "") +
            //   "%", // 报废率变化
            // returnCostChangePer:
            //   (res.returnCostChangePer < 0 ? "" : "+") +
            //   commonFun.formatDecimal(res.returnCostChangePer + "") +
            //   "%", // 报废成本变化
          };

          if (res.cakeSalesCount == 0 && res.norSalesCount == 0) {
            that.noContent = false;
          } else {
            that.noContent = true;
          }
          // that.getMain1();
          that.loading = false;
          that.isEnd += 1;
        },
        (err) => {
          console.log(err);
          that.loading = false;
          that.isEnd += 1;
        }
      );
    },
    // 充值
    getShopSalesRecharge() {
      let data = {
        DeptId: this.deptId,
        SalesDate: this.salesDate,
      };
      shopSalesDetailApi.getShopSalesRecharge(data).then(
        (res) => {
          this.shopSalesRechargeData = {
            amountChangePer:
              (res.amountChangePer < 0 ? "" : "+") +
              commonFun.formatDecimal(res.amountChangePer + "") +
              "%", // 充值金额变化
            presentChangePer:
              (res.presentChangePer < 0 ? "" : "+") +
              commonFun.formatDecimal(res.presentChangePer + "") +
              "%", // 赠送金额变化
            countChangePer:
              (res.countChangePer < 0 ? "" : "+") +
              commonFun.formatDecimal(res.countChangePer + "") +
              "%", // 充值笔数变化
            rechargeAmount: commonFun.getNumberFormatter(
              res.rechargeAmount + ""
            ), // 充值金额
            rechargePresent: commonFun.getNumberFormatter(
              res.rechargePresent + ""
            ), // 赠送金额
            rechargeCount: commonFun.getNumberFormatter(res.rechargeCount + ""), // 充值笔数
          };
          this.isEnd += 1;
        },
        (err) => {
          console.log(err);
          this.isEnd += 1;
        }
      );
    },
    // 营业额构成
    getShopSalesPayDetail() {
      let data = {
        DeptId: this.deptId,
        SalesDate: this.salesDate,
      };
      if (this.deptId != "" && this.deptId != null) {
        data["IsAllDept"] = false;
        data["deptIds"] = new Array(this.deptId);
      } else {
        if (this.isAllDept == true) {
          data["IsAllDept"] = true;
        } else {
          data["deptIds"] = this.dataItems.length > 0 ? this.dataItems : null;
          data["IsAllDept"] = false;
        }
      }
      shopSalesDetailApi.getShopSalesPayDetail(data).then(
        (res) => {
          this.txt = true; // item.payTypeName.length<7
          let per = 10000;
          let i = 0;
          let shopSalesPayDetail = res.filter((item, index) => {
            if (item.moneyPercent > 0) {
              let moneyPercent = commonFun.formatDecimal(
                item.moneyPercent + ""
              );
              per = per - moneyPercent * 100;
              item.moneyPercent = moneyPercent;
              item.money = commonFun.getNumberFormatter(item.money + "");
              if (item.payTypeName.length >= 7) {
                this.txt = false;
              }
              i++;
              return item;
            }
          });
          if (per > 0 && shopSalesPayDetail && shopSalesPayDetail.length > 0) {
            for (let i = 0; i < per; i++) {
              shopSalesPayDetail[i].moneyPercent =
                (parseFloat(shopSalesPayDetail[i].moneyPercent) * 100 + 1) /
                100;
              shopSalesPayDetail[i].moneyPercent = commonFun.formatDecimal(
                shopSalesPayDetail[i].moneyPercent + ""
              );
            }
          }
          this.shopSalesPayDetail = shopSalesPayDetail;
          this.isEnd += 1;
        },
        (err) => {
          console.log(err);
          this.isEnd += 1;
        }
      );
    },
    // 门店一览
    getShopSalesAllShop() {
      let data = {
        salesDate: this.salesDate,
      };
      if (this.deptId != "" && this.deptId != null) {
        data["IsAllDept"] = false;
        data["deptIds"] = new Array(this.deptId);
      } else {
        if (this.isAllDept == true) {
          data["IsAllDept"] = true;
        } else {
          data["deptIds"] = this.dataItems.length > 0 ? this.dataItems : null;
          data["IsAllDept"] = false;
        }
      }
      shopSalesDetailApi.getShopSalesAllShop(data).then(
        (res) => {
          this.shopSalesAllShop = res.map((item, index) => {
            item["salesMoney"] = commonFun.getNumberFormatter(
              item.salesMoney + ""
            );
            item["profit"] = commonFun.getNumberFormatter(item.profit + "");
            item["moneyComparePer"] =
              (item.moneyComparePer > 0 ? "+" : "") +
              commonFun.formatDecimal(item.moneyComparePer + "");
            item["profitComparePer"] =
              (item.profitComparePer > 0 ? "+" : "") +
              commonFun.formatDecimal(item.profitComparePer + "");
            return item;
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },

    getMain1() {
      this.loading = false;
      let cakeSalesAllPrice = this.shopSalesDetailData.cakeSalesAllPrice; // 生日蛋糕客单价
      let norSalesAllPrice = this.shopSalesDetailData.norSalesAllPrice; // 非生日蛋糕客单价
      let cakeSalesPer = null;
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("main1"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          confine: true,
          // position: ['50%', '10%'],
          formatter: function (value) {
            if (
              norSalesAllPrice == 0 &&
              cakeSalesAllPrice == norSalesAllPrice
            ) {
              return (
                value.name +
                "<br>金额:" +
                commonFun.getNumberFormatter(value.value + "") +
                "(50%)"
              );
            } else {
              if (!value.dataIndex) {
                return (
                  value.name +
                  "<br>金额:" +
                  commonFun.getNumberFormatter(value.value + "") +
                  "(" +
                  cakeSalesPer +
                  "%)"
                );
              } else {
                return (
                  value.name +
                  "<br>金额:" +
                  commonFun.getNumberFormatter(value.value + "") +
                  "(" +
                  commonFun.toDecimal2((1000 - cakeSalesPer * 10) / 10) +
                  "%)"
                );
              }
            }
          },
          // formatter:
          //   norSalesAllPrice == 0 && cakeSalesAllPrice == norSalesAllPrice
          //     ? "{b}<br>消费金额: {c} (50%)"
          //     : "{b}<br>消费金额: {c} ({d}%)"
        },
        color: ["#e5bc46", "#de8f57"],
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            label: {
              normal: {
                formatter: function (value) {
                  if (
                    norSalesAllPrice == 0 &&
                    cakeSalesAllPrice == norSalesAllPrice
                  ) {
                    return "50%";
                  } else {
                    if (!value.dataIndex) {
                      cakeSalesPer = commonFun.formatDecimal(
                        value.percent + ""
                      );
                      return cakeSalesPer + "%";
                    } else {
                      return (
                        commonFun.toDecimal2((1000 - cakeSalesPer * 10) / 10) +
                        "%"
                      );
                    }
                  }
                },
                // formatter:
                //   norSalesAllPrice == 0 && cakeSalesAllPrice == norSalesAllPrice
                //     ? "50%"
                //     : "{d}%",
                position: "inside",
              },
            },
            data: [
              { value: cakeSalesAllPrice, name: "生日蛋糕" },
              { value: norSalesAllPrice, name: "非生日蛋糕" },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    // 跳转门店
    showSalesByShop(id, name) {
      let selected = this.selected;
      this.$router.push({
        path: "/",
        query: { deptId: id, deptName: name, selected: selected },
      });
    },
    // 跳转趋势
    jumpTradTrends() {
      let deptId = this.deptId;
      let deptName = this.deptName;
      let isAllDept = this.isAllDept;
      let dataItems = this.dataItems;
      this.$router.push({
        path: "/tradTrends",
        query: {
          deptId: deptId,
          deptName: deptName,
          isAllDept: isAllDept,
          dataItems: dataItems,
        },
      });
    },
    // 切换时间
    searchByDate(date) {
      Indicator.open({
        text: "数据加载中",
        spinnerType: "fading-circle",
      });
      this.salesDate = date;
      this.weekDay = commonFun.getWeekDay(date);
      //  营业额，客单价，报废
      this.getShopSalesDetail();
      // 充值
      // this.getShopSalesRecharge();
      // 营业额构成
      this.getShopSalesPayDetail();
      // 门店一览
      if (!this.deptId) {
        this.getShopSalesAllShop();
      }
    },
    handleBottomChange(status) {
      this.bottomStatus = status;
    },
    loadBottom() {
      setTimeout(() => {
        let lastValue = this.list[this.list.length - 1];
        if (lastValue < 40) {
          for (let i = 1; i <= 10; i++) {
            this.list.push(lastValue + i);
          }
        } else {
          this.allLoaded = true;
        }
        this.$refs.loadmore.onBottomLoaded();
      }, 1500);
    },
  },
  mounted() {
    // 数据权限、功能权限控制 start
    shopSalesDetailApi.editOrGetInitAssistant().then(
      (res) => {
        if (res.featureItems.length > 0) {
          res.featureItems.map((item, index) => {
            if (item.indexOf("Daily") != -1) {
              if (this.featureItems[0].hasOwnProperty(item)) {
                this.featureItems[0][item] = true;
              }
            }
          });
          if (res.isAllDept == true) {
            this.isAllDept = true;
          } else {
            this.isAllDept = false;
            this.dataItems = res.dataItems;
          }
          this.initData();
          setTimeout(() => {
            for (let i = 1; i <= 20; i++) {
              this.list.push(i);
            }
            this.InitialLoading = false;
          }, 1500);
        }
      },
      (err) => {
        console.log(err);
      }
    );
    // 数据权限、功能权限控制 end

    let windowWidth = document.documentElement.clientWidth; //获取屏幕宽度
    if (windowWidth >= 768) {
      //这里根据自己的实际情况设置容器的高度
      this.wrapperHeight = document.documentElement.clientHeight - 105;
    } else {
      this.wrapperHeight = document.documentElement.clientHeight - 80;
    }
  },
  watch: {
    $route(to, from) {
      this.deptId = to.query.deptId || "";
      this.initData2();
    },
    isEnd(val) {
      if (val > 1) {
        this.isEnd = 0;
        Indicator.close();
      }
    },
  },
};
</script>
<style lang="less">
/***************************navbar*******************************/
.page-navbar.shopSales {
  font-size: 12px;
  .navbar-header {
    z-index: 999;
    width: 100%;
    position: fixed;
    top: 0;
    overflow: hidden;
    overflow-x: scroll;
    text-align: right;
    .mint-navbar.page-part {
      margin-bottom: 3px;
      width: 800%;
      // width: 175%;
      background-color: #fafafa;
      // float: right;
      .mint-tab-item {
        // padding: 14px 0 12px 0;
        padding: 0;
        color: #b3b3b3;
        .mint-tab-item-label {
          font-size: 14px;
          > div {
            padding: 14px 0 12px 0;
          }
        }
      }
      .mint-tab-item.is-selected {
        border-bottom: 2px solid #c59843;
        color: #c59843;
      }
    }
  }

  .introduct {
    font-size: 14px;
    padding: 16px 10px 10px 10px;
    word-wrap: break-word;
    > span {
      background-color: #fff !important;
      width: 18px;
      height: 18px;
      border-radius: 100%;
      border: 1px solid #bf9853;
      color: #bf9853;
      font-size: 12px;
      line-height: 12px;
      font-family: serif;
      font-weight: 600;
    }
  }

  .page-loadmore {
    padding: 0 10px;
    width: 100%;
    margin: 50px 0px 0px 0px;

    .page-loadmore-wrapper {
      height: auto !important;
      overflow: auto;
      .mint-loadmore {
        .mint-loadmore-content {
          .page-loadmore-list {
            .detail {
              width: 100%;
              width: 100%;
              background-color: #fff;
              margin-bottom: 12px;
              border-radius: 8px;
              padding: 20px 10px 10px;
              .title {
                color: #1b1b1b;
                font-size: 15px;
                text-align: center;
                font-weight: 600;
                padding-bottom: 10px;
              }
              .title-sub {
                font-size: 12px;
                text-align: center;
                padding-bottom: 20px;
                color: #969696;
              }
              .content {
                color: #c59942;
                text-align: center;
                font-weight: 500;
                padding-bottom: 10px;
                span {
                  font-size: 30px;
                }
                .unit {
                  font-size: 16px;
                  position: absolute;
                  margin-left: -25px;
                  margin-top: 8px;
                }
              }
              .compare {
                font-size: 12px;
                text-align: center;
                padding-bottom: 20px;
                > span {
                  color: #c59942;
                }
              }
              .compare-detail {
                display: flex;
                padding-bottom: 18px;
                > div {
                  width: 33%;
                  .compare-detail-title {
                    font-size: 12px;
                    text-align: center;
                    padding-bottom: 10px;
                    color: #969696;
                  }
                  .compare-detail-content {
                    color: #1b1b1b;
                    font-size: 16px;
                    text-align: center;
                    padding-bottom: 8px;
                  }
                  .compare-detail-value {
                    font-size: 12px;
                    color: #c59942;
                    text-align: center;
                  }
                  .isDiff {
                    color: #ec8a4b;
                  }
                }
              }
              .progress-detail {
                text-align: center;
                .start-txt {
                  font-size: 12px;
                  width: 42px;
                }
                .end-txt {
                  font-size: 12px;
                  text-align: left;
                  display: block;
                  padding-left: 6px;
                  width: 120px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }
                .endTxt2 {
                  width: 120px;
                }
                .mt-progress-runway {
                  background-color: transparent;
                }
                .mt-progress-progress {
                  height: 14px !important;
                  border-radius: 8px;
                }
                > div {
                  color: #999;
                  .mt-progress-progress {
                    background-color: #999;
                  }
                }
                > div:first-child {
                  color: #c89748;
                  .mt-progress-progress {
                    background-color: #c89748;
                  }
                }
                > div:nth-child(2) {
                  color: #debd78;
                  .mt-progress-progress {
                    background-color: #debd78;
                  }
                }
                > div:nth-child(3) {
                  color: #ecba1d;
                  .mt-progress-progress {
                    background-color: #ecba1d;
                  }
                }
                > div:nth-child(4) {
                  color: #ec8a4b;
                  .mt-progress-progress {
                    background-color: #ec8a4b;
                  }
                }
              }
              .cakeSales {
                margin: -30px 0 10px;
              }
              .cakeSales-detail {
                display: flex;
                font-size: 12px;
                align-content: center;
                align-items: center;
                color: #e5bc46;
                padding: 0px 10px 8px 10px;
                .cakeSales-detail-label {
                  width: 24px;
                  background-color: #e5bc46;
                  border-radius: 1px;
                  height: 10px;
                  margin-right: 10px;
                }
                .cakeSales-detail-name {
                  width: 75px;
                }
                .cakeSales-detail-value {
                  -webkit-box-flex: 1;
                  -ms-flex: 1;
                  flex: 1;
                }
                .cakeSales-detail-per {
                  width: 50px;
                }
              }
              .cakeSales-detail.isDiff {
                color: #ec8a4b;
                .cakeSales-detail-label {
                  background-color: #ec8a4b;
                }
              }
              .noContent {
                font-size: 12px;
                text-align: center;
                padding: 20px;
              }

              .check-trends {
                font-size: 14px;
                text-align: center;
              }
              // 门店一览
              .detail-table,
              .detail-table-content {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                background-color: #efefef;
                padding: 0px 10px;
                color: #969696;
                height: 46px;
                align-content: center;
                align-items: center;
                .name {
                  flex: 1;
                  font-size: 12px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .turnover {
                  width: 80px;
                  font-size: 12px;
                  text-align: center;
                  p:nth-child(2) {
                    color: #c59942;
                  }
                }
                .profit {
                  width: 70px;
                  font-size: 12px;
                  text-align: center;
                  p:nth-child(2) {
                    color: #ec8a4b;
                  }
                }
              }
              .notxt {
                text-align: center;
              }
              .detail-table-content {
                color: #666666;
              }
              .isEven {
                background-color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
.mint-indicator-wrapper {
  top: 35%;
  .mint-indicator-text {
    font-size: 12px;
  }
}
.mint-indicator-mask {
  z-index: 999;
}

/***************************navbar-end*******************************/
</style>



// WEBPACK FOOTER //
// src/view/shopSales/shopSales.vue